export default __webpack_public_path__ + "static/8-fd3923bf0e23d176152d39d10c01dc24.png";